import {observer} from 'mobx-react';
import React from 'react';
import {LessonTypeSelect} from '../../../../lib/components';
import {X4UnitStore} from '../X4UnitStore';

@observer
export class AddLessonForm extends React.Component<{ store: X4UnitStore }> {
  render() {
    const {store} = this.props;

    if (store.addLesson === null)
      return null;

    const name = store.addLesson.name;
    const lessonType = store.addLesson.lessonType;

    return (
      <div className="row" key="add-form">
        <div className="col">
          <div className={lessonType.formGroupClassName}>
            <LessonTypeSelect value={lessonType.value}
                              onChange={lessonType.setValue}
                              onBlur={lessonType.markTouched}/>
            <div className="invalid-text">Enter lesson type</div>
          </div>
        </div>
        <div className="col">
          <div className={name.formGroupClassName}>
            <input className="form-control" type="text"
                   value={name.value}
                   onChange={name.onChangeHandler}
                   onKeyDown={store.completeOnEnter}
                   onBlur={name.markTouched}/>
            <div className="invalid-text">Enter name</div>
          </div>
        </div>
      </div>);
  }
}
